/**
 * Test-attribute (`data-logz-test-subject`) values for the SIEM app-ui surfaces.
 * Grouped by feature area; values are kebab-case strings prefixed with `siem-`
 * (or `workspace-` for the cross-workspace selector).
 *
 * These enums are the canonical source of truth — references from app-ui pages
 * and e2e specs should import from here rather than hardcoding the strings.
 */
export var SiemRulesSubjects;
(function (SiemRulesSubjects) {
    SiemRulesSubjects["Page"] = "siem-rules-page";
    SiemRulesSubjects["Table"] = "siem-rules-table";
    SiemRulesSubjects["Count"] = "siem-rules-count";
    SiemRulesSubjects["NewRule"] = "siem-rules-new-rule";
    SiemRulesSubjects["FilterSearch"] = "siem-rules-filter-search";
    SiemRulesSubjects["RowActionsMenu"] = "siem-rules-row-actions-menu";
    SiemRulesSubjects["RowActionsTrigger"] = "siem-rules-row-actions-trigger";
    SiemRulesSubjects["RowActionEdit"] = "siem-rules-row-action-edit";
    SiemRulesSubjects["RowActionDuplicate"] = "siem-rules-row-action-duplicate";
    SiemRulesSubjects["RowActionInvestigate"] = "siem-rules-row-action-investigate";
    SiemRulesSubjects["RowActionDelete"] = "siem-rules-row-action-delete";
    SiemRulesSubjects["DeleteConfirm"] = "siem-rules-delete-confirm";
    SiemRulesSubjects["ProtectedBanner"] = "siem-rules-protected-banner";
    SiemRulesSubjects["ProtectedDuplicate"] = "siem-rules-protected-duplicate";
})(SiemRulesSubjects || (SiemRulesSubjects = {}));
export var SiemEventsSubjects;
(function (SiemEventsSubjects) {
    SiemEventsSubjects["Page"] = "siem-events-page";
    SiemEventsSubjects["Count"] = "siem-events-count";
    SiemEventsSubjects["RowActionsMenu"] = "siem-events-row-actions-menu";
    SiemEventsSubjects["RowActionsTrigger"] = "siem-events-row-actions-trigger";
    SiemEventsSubjects["RowActionViewDetails"] = "siem-events-row-action-view-details";
    SiemEventsSubjects["RowActionInvestigate"] = "siem-events-row-action-investigate";
    SiemEventsSubjects["RowActionViewHistory"] = "siem-events-row-action-view-history";
    SiemEventsSubjects["RowActionEditRule"] = "siem-events-row-action-edit-rule";
})(SiemEventsSubjects || (SiemEventsSubjects = {}));
export var SiemFeedsSubjects;
(function (SiemFeedsSubjects) {
    SiemFeedsSubjects["Page"] = "siem-feeds-page";
    SiemFeedsSubjects["Title"] = "siem-feeds-title";
    SiemFeedsSubjects["Table"] = "siem-feeds-table";
    SiemFeedsSubjects["Count"] = "siem-feeds-count";
    SiemFeedsSubjects["AddFeed"] = "siem-feeds-add-feed";
    SiemFeedsSubjects["RowActionsMenu"] = "siem-feeds-row-actions-menu";
    SiemFeedsSubjects["RowActionsTrigger"] = "siem-feeds-row-actions-trigger";
    SiemFeedsSubjects["RowActionEdit"] = "siem-feeds-row-action-edit";
    SiemFeedsSubjects["RowActionRetrySync"] = "siem-feeds-row-action-retry-sync";
    SiemFeedsSubjects["RowActionDelete"] = "siem-feeds-row-action-delete";
    SiemFeedsSubjects["DeleteConfirm"] = "siem-feeds-delete-confirm";
    SiemFeedsSubjects["FormPage"] = "siem-feedform-page";
    SiemFeedsSubjects["FormTitle"] = "siem-feedform-title";
    SiemFeedsSubjects["FormCancel"] = "siem-feedform-cancel";
    SiemFeedsSubjects["FormSubmit"] = "siem-feedform-submit";
    SiemFeedsSubjects["FormHeaders"] = "siem-feedform-headers";
    SiemFeedsSubjects["FormBody"] = "siem-feedform-body";
})(SiemFeedsSubjects || (SiemFeedsSubjects = {}));
export var SiemLookupsSubjects;
(function (SiemLookupsSubjects) {
    SiemLookupsSubjects["Page"] = "siem-lookups-page";
    SiemLookupsSubjects["Title"] = "siem-lookups-title";
    SiemLookupsSubjects["Table"] = "siem-lookups-table";
    SiemLookupsSubjects["Count"] = "siem-lookups-count";
    SiemLookupsSubjects["AddTrigger"] = "siem-lookups-add-trigger";
    SiemLookupsSubjects["AddMenu"] = "siem-lookups-add-menu";
    SiemLookupsSubjects["AddStatic"] = "siem-lookups-add-static";
    SiemLookupsSubjects["AddDynamic"] = "siem-lookups-add-dynamic";
    SiemLookupsSubjects["AddCsv"] = "siem-lookups-add-csv";
    SiemLookupsSubjects["RowActionsMenu"] = "siem-lookups-row-actions-menu";
    SiemLookupsSubjects["RowActionsTrigger"] = "siem-lookups-row-actions-trigger";
    SiemLookupsSubjects["RowActionEdit"] = "siem-lookups-row-action-edit";
    SiemLookupsSubjects["RowActionUpdateCsv"] = "siem-lookups-row-action-update-csv";
    SiemLookupsSubjects["RowActionViewHistory"] = "siem-lookups-row-action-view-history";
    SiemLookupsSubjects["RowActionViewHistoryDisabled"] = "siem-lookups-row-action-view-history-disabled";
    SiemLookupsSubjects["RowActionDelete"] = "siem-lookups-row-action-delete";
    SiemLookupsSubjects["DeleteConfirm"] = "siem-lookups-delete-confirm";
    SiemLookupsSubjects["StaticFormPage"] = "siem-staticlookupform-page";
    SiemLookupsSubjects["StaticFormTitle"] = "siem-staticlookupform-title";
    SiemLookupsSubjects["StaticFormCancel"] = "siem-staticlookupform-cancel";
    SiemLookupsSubjects["StaticFormSubmit"] = "siem-staticlookupform-submit";
    SiemLookupsSubjects["DynamicFormPage"] = "siem-dynamiclookupform-page";
    SiemLookupsSubjects["DynamicFormTitle"] = "siem-dynamiclookupform-title";
    SiemLookupsSubjects["DynamicFormCancel"] = "siem-dynamiclookupform-cancel";
    SiemLookupsSubjects["DynamicFormSubmit"] = "siem-dynamiclookupform-submit";
    SiemLookupsSubjects["FormName"] = "siem-lookupform-name";
    SiemLookupsSubjects["FormDescription"] = "siem-lookupform-description";
    SiemLookupsSubjects["CsvUploadModal"] = "siem-csvupload-modal";
    SiemLookupsSubjects["CsvUploadChooseFile"] = "siem-csvupload-choose-file";
    SiemLookupsSubjects["CsvUploadFileInput"] = "siem-csvupload-file-input";
    SiemLookupsSubjects["CsvUploadFilename"] = "siem-csvupload-filename";
    SiemLookupsSubjects["CsvUploadCancel"] = "siem-csvupload-cancel";
    SiemLookupsSubjects["CsvUploadSubmit"] = "siem-csvupload-submit";
})(SiemLookupsSubjects || (SiemLookupsSubjects = {}));
export var SiemDrilldownsSubjects;
(function (SiemDrilldownsSubjects) {
    SiemDrilldownsSubjects["Page"] = "siem-drilldowns-page";
    SiemDrilldownsSubjects["Title"] = "siem-drilldowns-title";
    SiemDrilldownsSubjects["Table"] = "siem-drilldowns-table";
    SiemDrilldownsSubjects["Count"] = "siem-drilldowns-count";
    SiemDrilldownsSubjects["Add"] = "siem-drilldowns-add";
    SiemDrilldownsSubjects["AddEmpty"] = "siem-drilldowns-add-empty";
    SiemDrilldownsSubjects["RowActionsMenu"] = "siem-drilldowns-row-actions-menu";
    SiemDrilldownsSubjects["RowActionsTrigger"] = "siem-drilldowns-row-actions-trigger";
    SiemDrilldownsSubjects["RowActionEdit"] = "siem-drilldowns-row-action-edit";
    SiemDrilldownsSubjects["RowActionDelete"] = "siem-drilldowns-row-action-delete";
    SiemDrilldownsSubjects["DeleteConfirm"] = "siem-drilldowns-delete-confirm";
    SiemDrilldownsSubjects["EditModal"] = "siem-drilldownedit-modal";
    SiemDrilldownsSubjects["EditCancel"] = "siem-drilldownedit-cancel";
    SiemDrilldownsSubjects["EditSubmit"] = "siem-drilldownedit-submit";
})(SiemDrilldownsSubjects || (SiemDrilldownsSubjects = {}));
export var SiemOsdPagesSubjects;
(function (SiemOsdPagesSubjects) {
    SiemOsdPagesSubjects["Summary"] = "siem-summary-page";
    SiemOsdPagesSubjects["Threats"] = "siem-threats-page";
    SiemOsdPagesSubjects["Dashboards"] = "siem-dashboards-page";
    SiemOsdPagesSubjects["Osd"] = "siem-osd-page";
})(SiemOsdPagesSubjects || (SiemOsdPagesSubjects = {}));
export var WorkspaceSelectorSubjects;
(function (WorkspaceSelectorSubjects) {
    WorkspaceSelectorSubjects["Trigger"] = "workspace-selector-trigger";
    WorkspaceSelectorSubjects["ManageAccounts"] = "workspace-selector-manage-accounts";
    /**
     * Prefix for per-workspace `<MenuItem>` options. Compose with the
     * `WorkspaceId` from `WorkspaceSelector/constants.ts` — e.g.
     * `${WorkspaceSelectorSubjects.OptionPrefix}-siem`.
     */
    WorkspaceSelectorSubjects["OptionPrefix"] = "workspace-option";
})(WorkspaceSelectorSubjects || (WorkspaceSelectorSubjects = {}));
//# sourceMappingURL=siem.enum.js.map